<template>
    <div class="maijia_head">
        <img src="../assets/images/maijia_logo.png" alt="">
        <p @click="handleLangChange">{{$i18n.locale == 'en'?'中文':'EN'}}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    created() {
        this.$i18n.locale = localStorage.getItem('language') || 'zh'
    },
    methods: {
        handleLangChange() {
            this.$i18n.locale = this.$i18n.locale == 'zh' ? 'en' : 'zh'
            localStorage.setItem('language', this.$i18n.locale);
        }
    }
}
</script>

<style lang="less" scoped>
.maijia_head {
    height: 37px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > img {
        width: 56.5px;
        height: 14.5px;
    }
    & > p {
        font-size: 14px;
        color: #ffffff;
    }
}
</style>